<template>
  <div ref="chart" style="width: 100%;height:400px;"></div>
</template>
<script>
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
import { LineChart, PieChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  PieChart,
  CanvasRenderer,
  UniversalTransition,
  DataZoomComponent,
]);

export default {
  name: "TimeLine",
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    loading(){
      return !this.$store.state[this.type].loaded
    },
    data() {
      return this.$store.state[this.type].data
    }
  },
  methods: {
    displayChart(){
      var myChart = echarts.init(this.$refs.chart);
      var option;

      let oneDay = 24 * 3600 * 1000;
      let base = +new Date(this.data[0].created_at);
      let last = +new Date(this.data[this.data.length-1].created_at);
      let date = [];
      let data = [];
      let nbDays = Math.floor((last-base)/oneDay)
      for (let i = 0; i < nbDays; i++) {
        var now = new Date(base);
        base += oneDay
        date.push(now.toLocaleDateString('fr-FR', {day: "numeric",month:"short",year:"numeric"}));
        data.push(this.data.findIndex(c => new Date(c.created_at) >= now)+1);
      }

      option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%'];
          }
        },
        title: {
          left: 'center',
          text: this.title
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: date
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        dataZoom: [
          {
            type: 'inside',
            start: this.data.length-11,
            end: this.data.length-1
          },
          {
            start: this.data.length-11,
            end: this.data.length-1
          }
        ],
        series: [
          {
            name: 'Nombre de groupes',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(0, 69, 79)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(0, 124, 140)'
                },
                {
                  offset: 1,
                  color: 'rgb(0, 69, 79)'
                }
              ])
            },
            data: data
          }
        ]
      };
      option && myChart.setOption(option);
    }
  },
  mounted() {
    if(!this.loading) {
      this.displayChart()
    }
  },
  watch: {
    loading() {
      if(!this.loading) {
        this.displayChart()
      }
    }
  }
}
</script>
